import { useCallback, useEffect, useState } from 'react'
import { useRouter } from 'next/router'

import { View } from './view'

export const TopMenuList = ({ className = '' }) => {
	const [activeItem, setActiveItem] = useState<string | null>(null)

	const { pathname } = useRouter()

	const handleToggle = useCallback(
		(name: string) => {
			setActiveItem(name)
		},
		[activeItem]
	)

	const mousemoveHandler = useCallback(({ target }) => {
		if (
			target &&
			typeof target.closest === 'function' &&
			!target.closest('[role="submenu"]') &&
			!target.closest('[role=menubutton]')
		) {
			setActiveItem(null)
		}
	}, [])

	useEffect(() => {
		if (activeItem) {
			document.addEventListener('mousemove', mousemoveHandler)
			return () => {
				document.removeEventListener('mousemove', mousemoveHandler)
			}
		}

		return undefined
	}, [activeItem])

	return View({
		className,
		activeItem,
		pathname,
		setActiveItem: handleToggle,
	})
}
